export const POOL_TAB = {
  MULTI: 'multiple',
  POINTS: 'points',
  REWARD: 'reward',
  RESTAKE: 'restake',
  SINGLE: 'single',
  STABLE: 'stable',
};

export const SORT_TYPE_MAP = {
  NORMAL: 'NORMAL',
  UP: 'UP',
  DOWN: 'DOWN',
};

export const DEFAULT_VAL = '--';

export const LBTC_MIN_GAS_AMOUNT = 0.0003;
